// H5 uni API 兼容层
import { wgs84ToGcj02 } from './region.js'

var uni = {
  navigateTo: function (o) {
    var u = (typeof o === 'string' ? o : (o && o.url)) || ''
    if (u) window.location.hash = '#' + (u.startsWith('/') ? u : '/' + u)
  },
  redirectTo: function (o) {
    var u = (typeof o === 'string' ? o : (o && o.url)) || ''
    if (u) window.location.replace(window.location.pathname + '#' + (u.startsWith('/') ? u : '/' + u))
  },
  reLaunch: function (o) {
    var u = (typeof o === 'string' ? o : (o && o.url)) || ''
    if (u) { window.location.hash = '#' + (u.startsWith('/') ? u : '/' + u); window.location.reload() }
  },
  navigateBack: function (o) {
    window.history.go(-((o && o.delta) || 1))
  },
  getStorageSync: function (k) {
    try {
      var v = localStorage.getItem(k)
      if (!v) return ''
      try { return JSON.parse(v) } catch (e) { return v }
    } catch (e) { return '' }
  },
  setStorageSync: function (k, v) {
    try { localStorage.setItem(k, typeof v === 'string' ? v : JSON.stringify(v)) } catch (e) { /* ignore */ }
  },
  removeStorageSync: function (k) {
    try { localStorage.removeItem(k) } catch (e) { /* ignore */ }
  },
  clearStorageSync: function () {
    try { localStorage.clear() } catch (e) { /* ignore */ }
  },
  getLocation: function (o) {
    var opts = o || {}
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (r) {
          var lat = r.coords.latitude
          var lng = r.coords.longitude
          // navigator.geolocation 返回 WGS84；type:'gcj02' 时转 GCJ02（对齐小程序 wx.getLocation）
          if (opts.type === 'gcj02') {
            var c = wgs84ToGcj02(lng, lat)
            lng = c.lng
            lat = c.lat
          }
          opts.success && opts.success({ latitude: lat, longitude: lng })
        },
        function (e) { opts.fail && opts.fail(e) },
        { enableHighAccuracy: true, timeout: 10000 }
      )
    } else {
      opts.success && opts.success({ latitude: 39.904, longitude: 116.407 })
    }
  },
  showToast: function (o) {
    var t = (typeof o === 'string' ? o : (o && o.title)) || ''
    var el = document.getElementById('h5-toast')
    if (!el) {
      el = document.createElement('div')
      el.id = 'h5-toast'
      el.style.cssText = 'position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);background:rgba(0,0,0,0.75);color:#fff;padding:0.2rem 0.4rem;border-radius:0.12rem;font-size:0.28rem;z-index:99999;pointer-events:none;white-space:nowrap;'
      document.body.appendChild(el)
    }
    el.textContent = t
    el.style.opacity = '1'
    clearTimeout(el._t)
    el._t = setTimeout(function () { el.style.opacity = '0' }, (o && o.duration) || 2000)
  },
  showLoading: function (o) {
    var t = (o && o.title) || '加载中...'
    var el = document.getElementById('h5-loading')
    if (!el) {
      el = document.createElement('div')
      el.id = 'h5-loading'
      el.innerHTML = '<div style="background:#fff;border-radius:0.16rem;padding:0.4rem;text-align:center"><div style="width:0.6rem;height:0.6rem;border:0.04rem solid #eee;border-top-color:#1890FF;border-radius:50%;animation:h5spin 0.8s linear infinite;margin:0 auto"></div><div class="h5lt" style="margin-top:0.2rem;font-size:0.28rem;color:#666"></div></div><style>@keyframes h5spin{to{transform:rotate(360deg)}}</style>'
      el.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.3);display:none;justify-content:center;align-items:center;z-index:99999;'
      document.body.appendChild(el)
    }
    el.querySelector('.h5lt').textContent = t
    el.style.display = 'flex'
  },
  hideLoading: function () {
    var el = document.getElementById('h5-loading')
    if (el) el.style.display = 'none'
  },
  showModal: function (o) {
    var opts = o || {}
    // 自定义弹窗，支持 confirmText/cancelText/confirmColor/cancelColor
    var id = 'h5-modal'
    // 移除旧弹窗
    var old = document.getElementById(id)
    if (old) old.remove()

    var wrap = document.createElement('div')
    wrap.id = id
    wrap.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.45);display:flex;align-items:center;justify-content:center;z-index:99999;'
    wrap.innerHTML =
      '<div style="background:#fff;border-radius:0.16rem;width:80%;max-width:300px;overflow:hidden;text-align:center;">' +
        (opts.title ? '<div style="padding:0.32rem 0.24rem 0;font-size:0.34rem;font-weight:700;color:#333;">' + opts.title + '</div>' : '') +
        '<div style="padding:0.32rem 0.24rem;font-size:0.30rem;color:#666;line-height:1.5;">' + (opts.content || '') + '</div>' +
        '<div style="display:flex;border-top:1px solid #eee;">' +
          '<div id="' + id + '-cancel" style="flex:1;height:0.88rem;line-height:0.88rem;font-size:0.30rem;color:' + (opts.cancelColor || '#999') + ';border-right:1px solid #eee;cursor:pointer;">' + (opts.cancelText || '取消') + '</div>' +
          '<div id="' + id + '-confirm" style="flex:1;height:0.88rem;line-height:0.88rem;font-size:0.30rem;color:' + (opts.confirmColor || '#007aff') + ';font-weight:600;cursor:pointer;">' + (opts.confirmText || '确定') + '</div>' +
        '</div>' +
      '</div>'

    document.body.appendChild(wrap)

    var remove = function () { if (wrap.parentNode) wrap.parentNode.removeChild(wrap) }

    document.getElementById(id + '-confirm').onclick = function () {
      remove()
      if (opts.success) opts.success({ confirm: true, cancel: false })
    }
    document.getElementById(id + '-cancel').onclick = function () {
      remove()
      if (opts.success) opts.success({ confirm: false, cancel: true })
    }
    // 点击遮罩不关闭（对齐小程序行为）
  },
  makePhoneCall: function (o) {
    var p = (typeof o === 'string' ? o : (o && o.phoneNumber)) || ''
    if (p) window.location.href = 'tel:' + p
  },
  openLocation: function (o) {
    var opts = o || {}
    // 使用高德地图URI API打开地点
    var marker = 'coord:' + opts.longitude + ',' + opts.latitude + ';name:' + encodeURIComponent(opts.name || '位置') + ';src=dongtaibashi'
    window.open('https://uri.amap.com/marker?' + marker)
  },
  login: function (o) {
    var opts = o || {}
    setTimeout(function () { opts.success && opts.success({ code: 'h5mockcode' }) }, 100)
  },
  getSystemInfoSync: function () {
    return { platform: 'h5', windowWidth: window.innerWidth, windowHeight: window.innerHeight }
  },
  setClipboardData: function (o) {
    var opts = o || {}
    var t = opts.data || ''
    if (navigator.clipboard) {
      navigator.clipboard.writeText(t)
    } else {
      var ta = document.createElement('textarea')
      ta.value = t
      ta.style.cssText = 'position:fixed;opacity:0;'
      document.body.appendChild(ta)
      ta.select()
      document.execCommand('copy')
      document.body.removeChild(ta)
    }
  }
}

if (typeof window.uni === 'undefined') window.uni = uni
export default uni
